const base = {
  endpointUri: "https://api.bamboopay-stage.com",
  faroUrl: "http://localhost:12347/collect", // TODO: Replace later
  version: "0.0.1",
  domainImage: "https://api.bamboopay-stage.com",
};

const local: typeof base = {
  ...base,
  endpointUri: "http://127.0.0.1:3005/api",
  faroUrl: "http://127.0.0.1:12347/collect",
  domainImage: "http://127.0.0.1:3005/api",
};

const stag: typeof local = {
  endpointUri: "https://api.bamboopay-stage.com",
  faroUrl: "https://faro.bamboopay-stage.com/collect",
  domainImage: "https://api.bamboopay-stage.com",
};

const prod: typeof local = {
  endpointUri: "https://api.bamboopay.com",
  faroUrl: "", // Temporarily disabled - faro.bamboopay.com DNS not configured
  domainImage: "https://api.bamboopay.com",
};

let values: typeof local;
if (import.meta.env.MODE === "production") {
  values = prod;
} else if (import.meta.env.MODE === "staging") {
  values = stag;
} else {
  values = local;
}

export const config = values;
